import { render, staticRenderFns } from "./FormSubmissionOverlay.vue?vue&type=template&id=63ff3716&scoped=true"
import script from "./FormSubmissionOverlay.vue?vue&type=script&lang=js"
export * from "./FormSubmissionOverlay.vue?vue&type=script&lang=js"
import style0 from "./FormSubmissionOverlay.vue?vue&type=style&index=0&id=63ff3716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff3716",
  null
  
)

export default component.exports